import { render } from "./Team.vue?vue&type=template&id=37de5d86"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__